export { renderAvatarGroupItem_unstable as renderAvatarGroupItem } from '@fluentui/react-avatar';
